import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="rounded-2xl overflow-hidden mb-10">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20and%20inviting%20anime%20style%20illustration%20of%20a%20cozy%20mobile%20phone%20screen%20displaying%20anime%20characters%2C%20surrounded%20by%20cherry%20blossom%20petals%2C%20soft%20warm%20lighting%20with%20golden%20hour%20glow%2C%20dreamy%20atmosphere%2C%20clean%20composition%2C%20high%20quality%20anime%20art%2C%20simple%20uncluttered%20design%2C%20warm%20coral%20and%20cream%20tones&width=1400&height=600&seq=cta-home-anime&orientation=landscape"
              alt="随时随地用手机免费追番"
              title="随时随地用手机免费追番 - 樱花动漫"
              className="w-full h-auto object-cover"
              loading="lazy"
            />
          </div>

          <div className="text-center">
            <p className="text-xl md:text-3xl font-heading text-foreground-900 leading-relaxed mb-2">
              <em className="text-foreground-500 not-italic font-light">{t('手机专为看动漫而生')}</em>
            </p>
            <p className="text-xl md:text-3xl font-heading text-foreground-900 font-bold leading-relaxed mb-2">
              {t('开始你的追番之旅')}
            </p>
            <p className="text-sm text-foreground-500 mb-8">
              {t('无论何时何地打开浏览器就能看')}
            </p>
            <Link
              to="/category/action"
              className="inline-flex items-center gap-2 bg-foreground-900 text-background-50 px-8 py-3 rounded-full text-sm font-medium hover:bg-foreground-800 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-play-circle-fill text-lg"></i>
              {t('开始免费观看')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}